<template>
	<div class="flexCol alit">
		<div class="flexCol alit justc top-bg">
			<div class="flexCol alit textbg">
				<div class="commpany-name">典型案例</div>
				<div class="commpany-desc">
					干广深耕农业产业链15年，以产业思维研发农业科技应用，以工业互联网思维来打造三农服务大数据平台，已先后运营产业大脑、无人农场、水肥一体系统、农企平台、国家级及省级产业园区平台、要素交易平台等100余个重点项目和硬件技术攻关!
				</div>
				<div class="commpany-desc-us">
					With 15 years of deep cultivation in the agricultural industry chain, Qianguang has adopted an industrial mindset to drive the R&D of agricultural technology applications and utilized industrial internet thinking to build a big data platform for agriculture, rural areas, and farmers services. The company has successively operated over 100 key projects and tackled hardware technology challenges, including industrial brain systems, unmanned farms, integrated water-fertilizer systems, agricultural enterprise platforms, national and provincial-level industrial park platforms, and factor trading platforms.
				</div>
			</div>
		</div>
		<div class="flexCol alit" style="background-color: #fff9f2;">
			<div class="title" style="margin-top: 30px;margin-bottom: 5px;">中央政治局委员、重庆市委书记袁家军调研奉节肉兔产业大脑和智慧养殖项目</div>
			<alienSwiper :slides="img1"></alienSwiper>
			<div class="desc">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				肉兔是奉节县重点打造的“一县一品”县域三产融合发展品牌，规划1000万只肉兔全产业链产业，主要建设万只祖代种兔场、商品兔示范场配套饲料厂、屠宰厂、有机肥厂、兔肉食品加工厂。采用统一规划、统一标准、智慧养殖、精准防疫、订单回收的企业+家庭农场的模式，发展一产养殖带动二产深加工，促进三产农文旅宿共同发展的产业化思路，2025年全产业链规模达15亿元。袁家军书记调研时指示：全产业链数字应用要强化科技创新，引导民营企业深度参与“四链”融合、“四侧”协同，加快推进大数据产业发展、企业数字化改造、数字场景建设，促进区域经济高质量发展。
			</div>
		</div>
		<div class="flexCol alit" style="background-color:  #f8fbff;">
			<div class="title" style="margin-top: 30px;margin-bottom: 5px;">
				易志坚：国家“百千万人才工程”第一、二层次人选、国家级有突出贡献的中青年专家、“国家最美科技工作者”</div>
			<alienSwiper :slides="img2"></alienSwiper>
			<div class="desc">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				重庆交通大学易志坚教授团队和华大基因以及千广科技合力拓展“沙变土”技术的科技观测全天候气象、土壤、作物、蒸腾数据应用，在内蒙、新疆、西藏、沙特、南非等地沙漠土壤化生态治理，以“天、地、生、用”四位一体实现整体生态改良方案并形成数据，在库布奇沙漠已经完成6万亩沙漠治理形成高标准农田，种植玉米、辣椒、土豆、食葵等作物，用数字技术实现精准灌溉和规模化种植的精准管理，形成了土壤改良、生态质量、农业生产、供应销售为一体的产业模型；
			</div>
		</div>
		<div class="flexCol alit" style="background-color: #fff9f2;">
			<div class="title" style="margin-top: 30px;margin-bottom: 5px;">国家工程院院士考察川南渝西种养循环示范基地</div>
			<alienSwiper :slides="img3"></alienSwiper>
			<div class="desc">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国畜牧科技论坛是经国家农业部批准，自2004年起每两年在重庆市荣昌区举办的全国性畜牧科技交流活动，由重庆市人民政府、中国农学会等单位联合主办，定位为中国畜牧界最高层次的学术盛会，被誉为“畜牧界的国际性盛会”。中国畜牧科技论坛20年成果暨国家畜牧科技城建设研讨会上，本届论坛在畜牧科技领域高端学术研讨、科研产业转化融合发展、提升论坛品牌等方面取得丰硕成果。论坛共举办各类分论坛和研讨会14场，发表主旨报告的领导、院士专家和企业家100余人次。论坛期间，形成畜牧行业共识成果《第八届中国畜牧科技论坛荣昌宣言》；成立西南优质安全猪肉全产业链生态联盟，生猪大数据产业发展公司、西南大学阿里云大数据与商务智能中心正式揭牌；荣昌区、重庆市畜牧科学院与东北农业大学、法国养猪研究院、俄罗斯莫斯科国立物理技术学院等29家国内外高校、科研机构和32家知名农牧企业签订院校共建、校企合作、院企合作协议；集中签约项目60个，总投资130亿元，涉及农牧高新等荣昌重要产业领域。
			</div>
		</div>
		<div class="flexCol alit" style="background-color:  #f8fbff;">
			<div class="title" style="margin-top: 30px;margin-bottom: 5px;">国家粮食安全单产提升示范项目-张掖市高标准农田改造建设</div>
			<alienSwiper :slides="img4"></alienSwiper>
			<div class="desc">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 项目建设高标农田3367.2亩，包括建设 83.55 ㎡智慧农业精准节水大数据云服务平台管理室 1
				座，智能节水灌溉、智能农情监测设施、智能管理系统、终端设备及无线远程传输等建设内容，其中高标准农田智能化示范区建设项目围绕高标准农田灌溉智能化的核心目标，通过配套先进、实用的精准监测和自动化控制设备，利用信息化科技手段，以标准化和规范化建设为抓手，主要进行水肥一体化智能化改造、气象、墒情、虫情、苗情、水情监测等农情数据采集与传输建设，完成从水源、田间、管理中心范围内数据采集一传输-决策一反馈一系列流程化工作，保障项目区农业灌溉智能化，引领农业现代化、智能化。
			</div>
		</div>
		<div class="flexCol alit" style="background-color: #fff9f2;width: 100%;">
			<div class="title" style="margin-top: 30px;margin-bottom: 5px;">更多项目</div>
			<alienSwiper7 :slides="img5" style="margin-bottom: 30px;"></alienSwiper7>
		</div>
	</div>
</template>

<script setup>
	import alienSwiper from '../../components/certifySwiper/index6.vue'
	import alienSwiper7 from '../../components/certifySwiper/index7.vue'
	import {
		ref
	} from 'vue';

	const img1 = ref([
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E8%82%89%E5%85%94%E9%A1%B9%E7%9B%AE/1.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E8%82%89%E5%85%94%E9%A1%B9%E7%9B%AE/2.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E8%82%89%E5%85%94%E9%A1%B9%E7%9B%AE/3.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E8%82%89%E5%85%94%E9%A1%B9%E7%9B%AE/4.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E8%82%89%E5%85%94%E9%A1%B9%E7%9B%AE/5.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E8%82%89%E5%85%94%E9%A1%B9%E7%9B%AE/6.png',
	])
	const img2 = ref([
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%B2%99%E5%8F%98%E5%9C%9F/1.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%B2%99%E5%8F%98%E5%9C%9F/2.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%B2%99%E5%8F%98%E5%9C%9F/3.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%B2%99%E5%8F%98%E5%9C%9F/4.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%B2%99%E5%8F%98%E5%9C%9F/5.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%B2%99%E5%8F%98%E5%9C%9F/6.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%B2%99%E5%8F%98%E5%9C%9F/7.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%B2%99%E5%8F%98%E5%9C%9F/8.png',
	])

	const img3 = ref([
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%B7%9D%E5%8D%97%E6%B8%9D%E8%A5%BF%E6%99%BA%E6%85%A7%E5%85%BB%E6%AE%96/1.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%B7%9D%E5%8D%97%E6%B8%9D%E8%A5%BF%E6%99%BA%E6%85%A7%E5%85%BB%E6%AE%96/2.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%B7%9D%E5%8D%97%E6%B8%9D%E8%A5%BF%E6%99%BA%E6%85%A7%E5%85%BB%E6%AE%96/3.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%B7%9D%E5%8D%97%E6%B8%9D%E8%A5%BF%E6%99%BA%E6%85%A7%E5%85%BB%E6%AE%96/4.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%B7%9D%E5%8D%97%E6%B8%9D%E8%A5%BF%E6%99%BA%E6%85%A7%E5%85%BB%E6%AE%96/5.png',
	])
	const img4 = ref([
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%BC%A0%E6%8E%96%E9%AB%98%E6%A0%87%E5%86%9C%E7%94%B0%E6%94%B9%E9%80%A0/1.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%BC%A0%E6%8E%96%E9%AB%98%E6%A0%87%E5%86%9C%E7%94%B0%E6%94%B9%E9%80%A0/2.jpg',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%BC%A0%E6%8E%96%E9%AB%98%E6%A0%87%E5%86%9C%E7%94%B0%E6%94%B9%E9%80%A0/3.jpg',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%BC%A0%E6%8E%96%E9%AB%98%E6%A0%87%E5%86%9C%E7%94%B0%E6%94%B9%E9%80%A0/4.jpg',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%BC%A0%E6%8E%96%E9%AB%98%E6%A0%87%E5%86%9C%E7%94%B0%E6%94%B9%E9%80%A0/5.jpg',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%BC%A0%E6%8E%96%E9%AB%98%E6%A0%87%E5%86%9C%E7%94%B0%E6%94%B9%E9%80%A0/6.png',
		'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%BC%A0%E6%8E%96%E9%AB%98%E6%A0%87%E5%86%9C%E7%94%B0%E6%94%B9%E9%80%A0/7.png',
	])

	const img5 = ref([{
			title: '西部地区最大的现代戈壁设施农业项目',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%9B%B4%E5%A4%9A%E9%A1%B9%E7%9B%AE/1.png',
			desc: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;占地3310.32亩，主要包括数字化育苗厂、ICA葡萄工厂、高效设施农业产业示范园、葡萄品种创制基地及数字农业创新应用基地项目充分利用戈壁滩、砂石地等非耕地资源，集成基质栽培、节水灌溉、品种改良、光热控制等现代技术，重构作物生长环境，拓展农业生产空间，将葡萄产业与数字农业相结合，最大限度减少投入降低成本，保障农产品的稳定供应与质量安全。千广将经验、知识和技术数据化，实现智能化、产业化、高效化生产，有效解决劳动力缺乏、行业风险高、生产效益低等问题，为优化数字农业基础设施，加深数字技术与传统葡萄产业的融合，完善甘州数字农业供给体系，促进张掖葡萄产业的高质量发展，延长葡萄产业产业链、增加产品附加值，提升农业现代化水平，加快实施乡村振兴的步伐突破了传统农业对水、土等自然条件的高度依赖，实现了“不与粮争地，不与地争肥”,项目建成后可实现年经济效益超亿元。'
		}, {
			title: '鲁渝协作--数字金银花产业带动乡村振兴',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%9B%B4%E5%A4%9A%E9%A1%B9%E7%9B%AE/2.png',
			desc: `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;订单：与上市药企鲁抗集团签定订单农业供应协议，未来五年拓展5万亩；<br/>
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总量：年需求量总产值 5亿元；打造全国最大的数字金银花产业平台；<br/>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基地：万州、石柱、秀山、巴南已种植万亩示范基地`
		}, {
			title: '万吨辣椒全产业链数字化运营体系',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%9B%B4%E5%A4%9A%E9%A1%B9%E7%9B%AE/3.png',
			desc: `规模：1万亩基地年产万吨辣椒、生物菌肥厂、辣椒初加工厂：<br/>
			   应用： 环境预警、苗情、大棚环控、水肥一体智控、农事作业、订单管理、供应链服务、交易平台；<br/>
			   价值：1、数字技术实现全产业链管理；2、增强物流、仓储和地方品牌提升；3、打造农业科技+销售一体化服务体系；`
		}, {
			title: '重庆丰都一县一品示范基地',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%85%B6%E4%BB%96%E9%A1%B9%E7%9B%AE/5.png',
			desc: `智控大棚、农耕研学、虫害知识库、认养农业、智慧教学<br/>
				价值：丰都新农人培训学校;丰都产学研实训基地;丰都一村一品实验基地;病虫害对县域作物影响研究`
		},
		// {
		// 	title: '2',
		// 	img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%9B%B4%E5%A4%9A%E9%A1%B9%E7%9B%AE/5.png',
		// 	desc: '2'
		// }, 
		{
			title: '千广生态智慧果园',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%85%B6%E4%BB%96%E9%A1%B9%E7%9B%AE/1.png',
			desc: `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;构建杏果生长周期物联网感知，农事作业、浇水施肥虫害防治、成熟采摘等环节全天候立体监测，实时查看生长状态和水肥一体化滴灌设备运行状态，虫情测报仪定时采集捕获害虫图像，与云库数据比对分析，AI识别害虫种类和数量，通过生态控制、理化诱控、生物防治等驱避方式，建立了绿色生态一体化防控体系，努力实现"做中国品质最好的杏子“的目标。`
		},
		// {
		// 	title: '2',
		// 	img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%9B%B4%E5%A4%9A%E9%A1%B9%E7%9B%AE/7.png',
		// 	desc: '2'
		// }, 
		{
			title: '投资土地整治+产业运营',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E5%85%B6%E4%BB%96%E9%A1%B9%E7%9B%AE/4.png',
			desc: '现已在投资整治高标农田4.3万亩，包括土地平整与土壤改良、灌溉与排水系统建设、田间道路与农田林网、电力与科技配套、生态保护与可持续发展的全生命周期管控服务.'
		}, {
			title: '土壤改良修复',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%9B%B4%E5%A4%9A%E9%A1%B9%E7%9B%AE/b4e12e9f342009d44f078ba3c6c204aa.png',
			desc: '土地平整:消除田块高低差，形成规整的梯田或平田，便于机械化作业和灌溉排水，调整田块大小和形状，适应规模化经营需求。土壤改良:增施有机肥，提升土壤有机质含量(目标≥1.5%)，改善土壤结构。酸碱度调节，通过施用石灰或酸性肥料，将土壤pH值调整至适宜作物生长范围。盐碱地治理，采用排水洗盐、化学改良剂等方法降低土壤含盐量。障碍土层破除，通过深耕、客土置换等方式消除砾石层、黏土层等限制'
		}, {
			title: '灌溉与排水系统建设',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%9B%B4%E5%A4%9A%E9%A1%B9%E7%9B%AE/e3b15f42c1a9a4546c73f144cc59fd20.png',
			desc: `
		灌溉工程:水源工程，修建水库、塘坝、泵站等，保障灌溉水源稳定。输配水系统，铺设管道、渠道(混凝土或防渗材料)，减少输水损失。田间灌溉设施，安装喷灌、滴灌、微喷等节水设备，实现精准灌溉(节水30%-50%)<br/>
		排水工程:明沟排水，开挖田间排水沟，防止涝渍;暗管排水，埋设地下管道，适用于低洼地或盐碱地改良。泵站排涝，在易涝区建设排涝泵站，确保暴雨后24小时内排除积水。`
		}, {
			title: '产业投资+产业运营',
			img: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/%E6%9B%B4%E5%A4%9A%E9%A1%B9%E7%9B%AE/89d59d6b5849134ef54c078fa53ea264.png',
			desc: '高标准农田建设需遵循“集中连片、整体推进”原则，结合当地实际制定差异化方案，确保建成后长期发挥效益。以种植、加工、销售形成一二三产融合发展生态闭环，带动当地近10亿元产值。'
		}
	])
</script>

<style scoped>
	.textbg{
		width: 50%;
		background-color: rgba(0, 0, 0, 0.4);
		border-radius: 10px;
		padding: 20px;
	}
	.top-bg{
		width: 100%;
		height: 800px;
		background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E7%BB%8F%E5%85%B8%E6%A1%88%E4%BE%8B/e60322dec95236ac3aa11dc54bcf8635.png');
		background-size: 100% 100%;
	}
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 70%;
		font-size: 22px;
		margin: 30px 0;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 50px 0 20px 0 !important;
		width: 70vw;
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>